module.exports = __webpack_public_path__ + "src/assets/textures/injection/syringe_bc.png";